var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMd)?_c('dashboard-desktop-navbar',{attrs:{"links":_vm.links}}):_vm._e(),(_vm.isMd)?_c('dashboard-mobile-drawer',{attrs:{"links":_vm.links}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }